"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./TimePicker.scss");

var _excluded = ["className", "isRange"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TimePickerComponent = function TimePickerComponent(_ref) {
  var className = _ref.className,
      isRange = _ref.isRange,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", null, isRange && /*#__PURE__*/_react["default"].createElement(_antd.TimePicker.RangePicker, _extends({
    defaultValue: props === null || props === void 0 ? void 0 : props.defaultValue,
    onChange: props.onChange,
    format: props.dateFormat,
    suffixIcon: props.suffixIcon,
    className: "".concat(className, " iiht-ant-picker"),
    dropdownClassName: "iiht-ant-date-picker-dropdown",
    getPopupContainer: function getPopupContainer() {
      return document.getElementById("app-container");
    },
    showNow: false
  }, props)) || /*#__PURE__*/_react["default"].createElement(_antd.TimePicker, _extends({
    defaultValue: props === null || props === void 0 ? void 0 : props.defaultValue,
    onChange: props.onChange,
    format: props.dateFormat,
    suffixIcon: props.suffixIcon,
    className: "".concat(className, " iiht-ant-picker"),
    dropdownClassName: "iiht-ant-date-picker-dropdown",
    getPopupContainer: function getPopupContainer() {
      return document.getElementById("app-container");
    }
  }, props, {
    showNow: false
  })));
};

var _default = TimePickerComponent;
exports["default"] = _default;